"use client";

import { useStoreBuilderContext } from "@/ui/admin/store-builder/store-builder-context";
import { defaultContent, isContentEmpty } from "@/ui/admin/tiptap-utils";
import { RichTextEditorLazy } from "../rich-text/rich-text-editor-lazy";
import type { Expandable } from "./component";

export const ExpandableRichText = ({ content, idx }: { content: unknown; idx: number }) => {
	const isEmpty = isContentEmpty(content);

	const { saveSelectedPageSectionField } = useStoreBuilderContext<typeof Expandable>();

	return (
		<RichTextEditorLazy
			content={isEmpty ? defaultContent : content}
			toolbarOverrides={["bold", "italic", "alignLeft", "alignCenter", "alignRight", "bulletList"]}
			onChange={(content) => {
				saveSelectedPageSectionField({ fieldPath: `expandable.${idx}.content`, value: content });
			}}
		/>
	);
};
